"use client";
import { Bell } from "lucide-react";
import { useState } from "react";
import useNavigatorPermissions from "@/lib/useNavigatorPermission";
import DefaultNotificationPermissionDialogContent from "./default-notification-permission-dialog-content";
import DeniedNotificationPermissionDialogContent from "./denied-notifiation-permission-dialog-content";
import NotificationTopicsDialogContent from "./notification-topics-dialog-content";
import { useTranslations } from "next-intl";
import { Credenza, CredenzaTrigger } from "../ui/credenza";

export default function NotificationBell() {
  const t = useTranslations("SiteHeader");

  const [open, setOpen] = useState(false);
  const notificationPermission = useNavigatorPermissions("notifications");
  return (
    <Credenza open={open} onOpenChange={setOpen}>
      <CredenzaTrigger asChild>
        <div
          className="flex flex-row items-center px-2 transition-opacity duration-200 opacity-50 cursor-pointer hover:pl-4 group hover:bg-transparent hover:opacity-80"
        >
          <div className="w-0 text-sm font-normal transition-all opacity-0 group-hover:w-14 group-hover:opacity-100 text-nowrap">
            {t('news')}
          </div>
          <Bell className="w-4 h-4" strokeWidth="1.5" />
        </div>
      </CredenzaTrigger>
      {notificationPermission == null && (
        <DefaultNotificationPermissionDialogContent setOpen={setOpen} />
      )}
      {notificationPermission == false && (
        <DeniedNotificationPermissionDialogContent setOpen={setOpen} />
      )}
      {notificationPermission == true && (
        <NotificationTopicsDialogContent setOpen={setOpen} />
      )}
    </Credenza>
  );
}
